import React from "react";

export default function HeaderGradient() {
const gradientStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  // backgroundImage: 'linear-gradient(166deg, #756ed9, #6c64e5 20%, #6A92DA 40%,  white 40%, white 100%)',
  backgroundImage: 'linear-gradient(166deg, #a36cff, #6257FF 20%, #5E98FF 40%,  white 40%, white 100%)',
  //  backgroundImage: 'radial-gradient(circle, rgba(126, 34, 206, 1) 0%, rgba(79, 70, 229, 1) 70%)',
  
  zIndex: -1,
  pointerEvents: 'none',
};
  return <div style={gradientStyle}></div>;
}
